import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/prediction', label: 'Prediction', icon: '🔬' },
  { to: '/analysis',   label: 'Analysis',   icon: '📊' },
  { to: '/analytics',  label: 'Analytics',  icon: '🔭' },
  { to: '/history',    label: 'History',    icon: '📋' },
  { to: '/insights',   label: 'Insights',   icon: '💡' },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav className="bg-slate-900/95 backdrop-blur border-b border-slate-700/50 sticky top-0 z-50 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-14 md:h-16">

          {/* Logo */}
          <Link to="/prediction" className="flex items-center gap-2 group" onClick={() => setOpen(false)}>
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-base md:text-lg shadow-lg group-hover:scale-110 transition-transform">🧠</div>
            <div>
              <div className="font-black text-white text-xs md:text-sm leading-none">AI Stress</div>
              <div className="text-xs text-slate-400 leading-none hidden sm:block">Dashboard</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map(({ to, label, icon }) => {
              const active = pathname === to;
              return (
                <Link key={to} to={to}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold transition-all duration-200 ${active ? 'bg-gradient-to-r from-blue-600/30 to-purple-600/30 text-white border border-blue-500/30' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}>
                  <span>{icon}</span>
                  <span className="hidden lg:inline">{label}</span>
                  {active && <span className="w-1.5 h-1.5 rounded-full bg-blue-400"/>}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-2">
            {/* Live indicator */}
            <div className="hidden sm:flex items-center gap-2 bg-slate-800/60 border border-slate-700/50 rounded-xl px-3 py-1.5">
              <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"/>
              <span className="text-xs text-slate-400 font-medium">Live</span>
            </div>

            {/* Hamburger */}
            <button onClick={() => setOpen(!open)}
              className="md:hidden w-9 h-9 flex flex-col items-center justify-center gap-1.5 bg-slate-800 border border-slate-700 rounded-xl">
              <span className={`w-5 h-0.5 bg-slate-300 rounded transition-all duration-300 ${open ? 'rotate-45 translate-y-2' : ''}`}/>
              <span className={`w-5 h-0.5 bg-slate-300 rounded transition-all duration-300 ${open ? 'opacity-0' : ''}`}/>
              <span className={`w-5 h-0.5 bg-slate-300 rounded transition-all duration-300 ${open ? '-rotate-45 -translate-y-2' : ''}`}/>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 overflow-hidden ${open ? 'max-h-96 border-t border-slate-700/50' : 'max-h-0'}`}>
        <div className="px-4 py-3 space-y-1 bg-slate-900/98">
          {NAV_LINKS.map(({ to, label, icon }) => {
            const active = pathname === to;
            return (
              <Link key={to} to={to} onClick={() => setOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${active ? 'bg-gradient-to-r from-blue-600/20 to-purple-600/20 text-white border border-blue-500/30' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}>
                <span className="text-lg">{icon}</span>
                <span>{label}</span>
                {active && <span className="ml-auto w-2 h-2 rounded-full bg-blue-400"/>}
              </Link>
            );
          })}
          <div className="flex items-center gap-2 px-4 py-2">
            <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"/>
            <span className="text-xs text-slate-400">Live</span>
          </div>
        </div>
      </div>
    </nav>
  );
}
